import React from 'react';
import ReactGA from 'react-ga';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

function DisplayTab({ onChange, value }) {
  function handleClick(event, newValue){
    if(newValue !== value){
      ReactGA.event({
        category: 'Main Display Tab',
        action: 'Switched Main Display Tab',
        label: `New Display: ${value}`,
      });

      onChange(newValue);
    }
  }
  
  return (
    <Tabs centered value={value} onChange={handleClick} aria-label="Info Display Tab">
      <Tab label="Live" value="live" />
      <Tab label="Boxscore" value="boxscore" />
      <Tab label="Other" value="other" />
    </Tabs>
  )
}

export default DisplayTab;
